import { render, staticRenderFns } from "./SeatourDetailPage.vue?vue&type=template&id=1f16f600&scoped=true&"
import script from "./SeatourDetailPage.vue?vue&type=script&lang=js&"
export * from "./SeatourDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16f600",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f16f600')) {
      api.createRecord('1f16f600', component.options)
    } else {
      api.reload('1f16f600', component.options)
    }
    module.hot.accept("./SeatourDetailPage.vue?vue&type=template&id=1f16f600&scoped=true&", function () {
      api.rerender('1f16f600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/SeatourDetailPage.vue"
export default component.exports